// XX团队投研进行时
const generate12CharUniqueId = () => {
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  const timestampPart = Date.now().toString().slice(-4);
  const perfPart = Math.floor(performance.now()).toString().slice(-4);
  let base = timestampPart + perfPart; // 8位

  const remainingLength = 12 - base.length;
  let allChars = base.split("");

  // 直接生成所需长度的随机字母，避免拼接循环
  for (let i = 0; i < remainingLength; i++) {
    allChars.push(letters.charAt(Math.floor(Math.random() * letters.length)));
  }

  // Fisher-Yates 洗牌算法，快速高效打乱
  for (let i = allChars.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [allChars[i], allChars[j]] = [allChars[j], allChars[i]];
  }

  return allChars.join("");
};
const routes = [
  {
    // 领航家·VIP大直播（由 live 项目迁移）
    path: "/viplive",
    name: "viplive",
    component: () => import("@/views/viplive/index.vue")
  },
  {
    path: "/zblogin/:sign",
    name: "zblogin",
    component: () => import("@/views/zblogin/index.vue")
  },
  {
    path: "/hzlogin/:sign",
    name: "hzlogin",
    component: () => import("@/views/hzlogin/index.vue")
  },
  {
    path: "/bghlogin/:sign",
    name: "bghlogin",
    component: () => import("@/views/hzlogin/bgh.vue")
  },
  {
    path: `/${process.env.VUE_APP_MTOZB_URL}/bghlogin/:sign`,
    name: "mtozburlbghlogin",
    component: () => import("@/views/hzlogin/bgh.vue")
  },
  {
    path: `/${process.env.VUE_APP_MTOZB_URL}/hzlogin/:sign`,
    name: "mtozburlhzlogin",
    component: () => import("@/views/hzlogin/index.vue")
  },
  {
    path: "/hzlive/:sign/:random?",
    beforeEnter: (to, from, next) => {
      if (!to.params.random) {
        const randomParam = generate12CharUniqueId();
        next({
          name: to.name,
          params: { ...to.params, random: randomParam },
          query: to.query,
          hash: to.hash
        });
      } else {
        next();
      }
    },
    name: "hzlive",
    component: () => import("@/views/hzlive/index.vue")
  },
  {
    path: `/${process.env.VUE_APP_MTOZB_URL}/hzlive/:sign/:random?`,
    beforeEnter: (to, from, next) => {
      if (!to.params.random) {
        const randomParam = generate12CharUniqueId();
        next({
          name: to.name,
          params: { ...to.params, random: randomParam },
          query: to.query,
          hash: to.hash
        });
      } else {
        next();
      }
    },
    name: 'mtozburlhzlive',
    component: () => import("@/views/hzlive/index.vue")
  },
  {
    path: `/bgh/:sign/:random?`,
    beforeEnter: (to, from, next) => {
      if (!to.params.random) {
        const randomParam = generate12CharUniqueId();
        next({
          name: to.name,
          params: { ...to.params, random: randomParam },
          query: to.query,
          hash: to.hash
        });
      } else {
        next();
      }
    },
    name: "bgh",
    component: () => import("@/views/bgh/index.vue"),
  },
  {
    path: `/${process.env.VUE_APP_MTOZB_URL}/bgh/:sign/:random?`,
    beforeEnter: (to, from, next) => {
      if (!to.params.random) {
        const randomParam = generate12CharUniqueId();
        next({
          name: to.name,
          params: { ...to.params, random: randomParam },
          query: to.query,
          hash: to.hash
        });
      } else {
        next();
      }
    },
    name: 'mtozburlbgh',
    component: () => import("@/views/bgh/index.vue"),
  },
  {
    path: "/zb/:sign",
    name: "zb",
    component: () => import("@/views/zb/index.vue")
  },

  {
    path: "/zbv2/:sign",
    name: "zbv2",
    component: () => import("@/views/zb/indexv2.vue")
  },
  {
    path: "/pxzb/:sign",
    component: () => import("@/views/pxzb/index.vue")
  },
  {
    path: "/hdxc",
    component: () => import("@/views/hdxc/index.vue")
  },
  {
    path: "/hdxc/live/:sign",
    component: () => import("@/views/hdxc/live/index.vue")
  },
  {
    path: "/prodlink",
    component: () => import("@/views/prodlink/index.vue"),
    meta: {
      title: "直播链接"
    }
  }
];

export default routes;
